import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box component="footer" sx={{ p: 2, textAlign: 'center', bgcolor: 'background.paper', mt: 'auto' }}>
      <Typography variant="body2" color="textSecondary">
        &copy; {new Date().getFullYear()} BKAB. Alla rättigheter förbehållna.
      </Typography>
    </Box>
  );
}

export default Footer;